import { regionName } from "lib/region";
import { useRegion } from "render/context/RegionContext";
import Badge from "./Badge";

/**
 * Names the region this app is serving. Renders nothing when the region is unknown, rather
 * than claiming a region it cannot confirm. A specialist who loses track of their region can
 * apply the wrong excision threshold, which is why this is asked for on clinical grounds as
 * well as data-integrity ones (AB#95463).
 */
export default function RegionBadge() {
  const region = useRegion();

  if (region.status !== "resolved") {
    return null;
  }

  const name = regionName(region.servingRegion);

  return <Badge text={name} title={`You are working in ${name}`} />;
}
